/**
 * Configuration file for Kompack partner module
 * Contains table field definitions and sorting options for the partner listing
 * @module views/pages/kompack/partner/config
 */
import { IDR } from '@/libs/currency'
import { defaultThClass } from '../config'

export const optionsPartnerOrderBy = [
  {
    text: 'Semua Aktivitas',
    value: 'all',
  },
  {
    text: 'Register',
    value: 'register',
  },
  {
    text: 'Last Packing',
    value: 'last-packing',
  },
  {
    text: 'Most Order',
    value: 'most-order',
  },
]

export const partnerStatusOptions = [
  {
    text: 'Semua Status',
    value: '0',
  },
  {
    text: 'Partner Baru',
    value: '1',
  },
  {
    text: 'Aktif',
    value: '2',
  },
  {
    text: 'Pasif',
    value: '3',
  },
  {
    text: 'In-Active',
    value: '4',
  },
]

const defaultClass = {
  tdClass: 'font-[400] text-[#333333] !text-[14px]',
  class: `${defaultThClass} !text-[#333333]`,
}

const tdClass = 'font-[400] text-[#333333] !text-[14px] align-top'
const thClass = `${defaultThClass} !text-[#333333] !text-[14px] align-middle`

/**
 * Configuration for the partner listing table
 * @type {Array}
 */
export const fields = [
  {
    key: 'no',
    label: 'No',
    tdClass,
    thClass,
  },
  {
    key: 'name',
    label: 'Nama Partner',
    thClass: `${thClass} !min-w-[200px]`,
    tdClass,
  },
  {
    key: 'business_name',
    label: 'Nama Bisnis',
    thClass: `${thClass} !min-w-[213px]`,
    tdClass,
    formatter: value => value || '-',
  },
  {
    key: 'contact',
    label: 'Kontak',
    thClass: `${thClass} !min-w-[260px]`,
    tdClass,
  },
  {
    key: 'total_order',
    label: 'Jumlah Order',
    thClass: `${thClass} !min-w-[160px]`,
    tdClass,
    sortable: true,
  },
  {
    key: 'warehouses',
    label: 'Lokasi Gudang dan Stock',
    thClass: `${thClass} !min-w-[280px]`,
    tdClass,
  },
  {
    key: 'total_fulfillment_fee',
    label: 'Transaksi Biaya Fulfillment',
    thClass: `${thClass} !min-w-[280px]`,
    tdClass,
    formatter: value => (value ? IDR(value) : '-'),
  },
  {
    key: 'total_kompack_revenue',
    label: 'Revenue Kompack dari Biaya Fulfillment',
    thClass: `${thClass} !min-w-[280px]`,
    tdClass,
    formatter: value => (value ? IDR(value) : '-'),
  },
  {
    key: 'status',
    label: 'Status',
    thClass: `${thClass} !min-w-[180px]`,
    tdClass,
  },
  {
    key: 'partner_id',
    label: 'Rincian',
    thClass: `${thClass} !min-w-[180px]`,
    tdClass,
  },
]
